import React, { useState } from "react";
import styled from "styled-components";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useMutation } from "@apollo/client";
import { LOGIN_USER } from "../apollo-client/mutations";
import { Navigate } from "react-router-dom";

const Background = styled.div`
  background-color: black;
  width: 100%;
  height: 100vh;
`;

function LandingPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [login] = useMutation(LOGIN_USER, {
    onCompleted: (data) => {
      localStorage.setItem("token", data.login.jwt);
      window.location.reload();
    },
  });

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  if (isLoggedIn) return <Navigate to="/abuse-reports" />;
  return (
    <Background>
      <Modal isOpen={true}>
        <ModalHeader>Meldungskonsole-Blag</ModalHeader>
        <ModalBody p={10}>
          <p>Bitte loggen Sie sich ein, um die Konsole zu nutzen!</p>
          <Form>
            <FormGroup>
              <Label for="exampleEmail">Email</Label>
              <Input
                type="email"
                name="email"
                id="exampleEmail"
                placeholder="with a placeholder"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="examplePassword">Password</Label>
              <Input
                type="password"
                name="password"
                id="examplePassword"
                placeholder="password placeholder"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={async () =>
              await login({
                variables: { email, password },
              })
            }
          >
            Login
          </Button>
        </ModalFooter>
      </Modal>
    </Background>
  );
}

export default LandingPage;
